export class Controller {

	/** @ngInject */
	constructor($state, HardTokenService, Alert,DestructiveOperationModal) {
		this.HardTokenService = HardTokenService;
		this.Alert = Alert;
		this.$state = $state;
		this.DestructiveOperationModal=DestructiveOperationModal;
	}
	$onInit() {
		this.initInputs();
		this.hardToken = angular.copy(this.token);
		console.log(this);
	}
	
	getState(){
        if (this.hardToken.isSecondaryDeviceOfUser){
            return this.hardToken.status === 'ACTIVE' ? 'secondary_device_of_user' : 'secondary_device_of_user_blocked';
        }
        if (this.hardToken.hasAccounts){
            return this.hardToken.status === 'ACTIVE' ? 'has_assigned_accounts' : 'has_assigned_accounts_blocked';
        }
        return this.hardToken.status==='ACTIVE' ? 'no_account_assigned' : 'no_account_assigned_blocked';
    }
    
    isNotModified(){
		return angular.equals(this.hardToken, this.token);
	}

	/** @private */
	initInputs() {
		this.edit = {};
		this.show = {};
	}
	
	/** @private */
	updateToken(value) {
		this.initInputs();
		angular.extend(this.token, value);
		angular.extend(this.hardToken, value);
	}
	/** @private */
	replaceToken(value) {
		this.initInputs();
		angular.copy(value, this.token);
		angular.copy(value, this.hardToken);
	}
	
	restoreToken() {
		this.initInputs();
		angular.copy(this.token,this.hardToken);
	}
	
	save() {
		this.isSaving = true;
		this.HardTokenService
			.save(this.hardToken)
			.then((response) => {
				this.replaceToken(response);
				this.Alert('success', 'hard_tokens.edit.saved_successfully');
			})
			.catch((error) => {
				console.log(error);
				this.restoreToken();
				this.Alert('danger', 'hard_tokens.edit.failed_save');
			}).finally(() => this.isSaving = false);
	}

	showDeleteModal() {
		const companyId = this.companyId;
		const url = `app/rest/admin/company/${companyId}/hardtoken/${this.hardToken.id}`;
		this.DestructiveOperationModal({
			titleKey: 'hard_tokens.management.delete',
			textKey: this.hardToken.isSecondaryDeviceOfUser, 'hard_tokens.management.info_secondarydevice' : 'hard_tokens.management.info',
			http: { method: 'DELETE', url }
		}).then(() => {
			this.$state.go('company.hard-token-management', {}, { reload: 'company.hard-token-management' });
			this.Alert('success', 'hard_tokens.management.delete.success');
		});
	}

	enable() {
		this.HardTokenService
			.enable(this.hardToken)
			.then(() => {
				this.updateToken({ status: 'ACTIVE'  });
				//this.$state.reload($state.current);
				this.Alert('success', 'hard_tokens.edit.enabled_successfully');
			})
			.catch((error) => {
				console.log(error);
				this.restoreToken();
				this.Alert('danger', 'hard_tokens.edit.failed_to_enable');
			});

	}

	disable() {

		this.HardTokenService
			.disable(this.hardToken)
			.then(() => {
				this.updateToken({status: 'INACTIVE' });
				//this.$state.reload($state.current);
				this.Alert('success', 'hard_tokens.edit.disabled_successfully');
			})
			.catch((error) => {
				console.log(error);
				this.restoreToken();
				this.Alert('danger', 'hard_tokens.edit.failed_to_disable');
			});
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/settings/hard-token-settings.controller.js